/**
 * Hook to get the current logged-in user's ID
 */

import { useState, useEffect } from "react";

export function useCurrentUserId(): string {
  const [userId, setUserId] = useState<string>("19x1"); // fallback

  useEffect(() => {
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const user = JSON.parse(userStr);
        if (user.id) {
          setUserId(user.id);
        }
      }
    } catch {
      // Keep fallback
    }
  }, []);

  return userId;
}

export function getCurrentUserId(): string {
  try {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user.id) {
        return user.id;
      }
    }
  } catch {
    // Ignore
  }
  return "19x1"; // fallback
}
